import adacLogo from './ADAC-Logo.svg';

export const ADACLogo = ({ className }: { className?: string }) => {
  // TODO: Consider translated ALT
  return <img className={className} src={adacLogo} alt='Allgemeiner Deutscher Automobil-Club' />;
};
